// extracted by mini-css-extract-plugin
export var formContainer = "_by-0";
export var message = "_by-1";